<app-header-hs1 titulo="Pessoa" (eventSave)="save()" (eventCancel)="voltar()" [deletavel]="deletavel" [editavel]="true" (eventDelete)="delete()"/>

<ion-content [fullscreen]="true">
  <ion-list [inset]="true">
    <form #form="ngForm">
      <ion-item >
        <ion-input name="nome" label-placement="floating" required [(ngModel)]="entidade.nome">
          <div slot="label">Nome
            <ion-text color="danger">*</ion-text>
          </div>
        </ion-input>
      </ion-item>

      <ion-item>
        <ion-input name="email" label-placement="floating" email required type="email"   [(ngModel)]="entidade.email" >
          <div slot="label">Email
            <ion-text color="danger">*</ion-text>
          </div>
        </ion-input>
      </ion-item>
      <ion-item>
        <ion-select interface="popover" name="funcoes" label-placement="floating" label="Funções" [(ngModel)]="entidade.funcoes"
                    aria-label="Biomas"
                    [multiple]="true">
          <ion-select-option *ngFor="let fu of funcoes" [value]="fu">{{ fu }}</ion-select-option>
        </ion-select>
      </ion-item>

    </form>
  </ion-list>
</ion-content>
<app-rodape [exibirBotoes]="false"/>
